import React from 'react';
import styleCom from "./REGCOM.module.scss";
import toast from "components/Toast/Toast";
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import RadioGroup from "../../components/Radio/RadioGroup";


const RenderHtml = (props) => {

    let lesion1Html=<></>;
    const radioOptions = [
         {mapCd: "lowSes", value: "0", label: "건강보험"}  //자격여부
        ,{mapCd: "lowSes", value: "1", label: "차상위/급여1,2종"}
        ,{mapCd: "presetYn", value: "0", label: "No"}
        ,{mapCd: "presetYn", value: "1", label: "Yes"}
    ];

    function getOptionList(cdValue) {
        return radioOptions.filter(option => option.mapCd === cdValue);
    }


    /* Event ****************************************************************************** */

    const compValue = (mpaCd) => {
        return props.getBaseVal(mpaCd);
    }

    const compChange = (mapCd, value) => {
        props.setBaseVal(mapCd, value);

    }

    /* ****************************************************************************** Event */

    lesion1Html =
        <>
            <div className={styleCom.title_wrap}>
                <h3>Basic Information</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={3} colSize={['25%', '75%', '25%', '75%']} rowSize={'56px'}>
                    <div>Height</div>
                    <div style={{height: "56px"}}>
                        <InputUnitText type={"number"} unit={"cm"}
                                       value={props.getBaseVal('height')}
                                       onChange={(value) => props.setBaseVal('height', value)}/>
                        * Range: 100~230
                    </div>
                    <div>Weight</div>
                    <div>
                        <InputUnitText type={"number"} unit={"kg"}
                                       value={props.getBaseVal('weight')}
                                       onChange={(value) => props.setBaseVal('weight', value)}/>
                        * Range: 30~150
                    </div>
                    <div>자격구분</div>
                    <div>
                        <RadioGroup options={getOptionList('lowSes')} selectedValue={compValue('lowSes')}
                                    onChange={(val) => props.setBaseVal('lowSes', val)}/>
                    </div>
                    <div>흡연여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('smokingYn')}
                                    onChange={(val) => props.setBaseVal('smokingYn', val)}/>
                    </div>
                    <div>음주여부</div>
                    <div className={"col_merge"}>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('alcoholYn')}
                                    onChange={(val) => props.setBaseVal('alcoholYn', val)}/>
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap}>
                <h3>Medical History</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={4} colSize={['25%', '75%', '25%', '75%']} rowSize={'56px'}>
                    <div>당뇨병 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('dyslipidemiaYn')}
                                    onChange={(val) => props.setBaseVal('dyslipidemiaYn', val)}/>
                    </div>
                    <div>심방세동 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('afYn')}
                                    onChange={(val) => props.setBaseVal('afYn', val)}/>
                    </div>
                    <div>만성 신장 질환 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('ckdYn')}
                                    onChange={(val) => props.setBaseVal('ckdYn', val)}/>
                    </div>
                    <div>투석 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('dialysisYn')}
                                    onChange={(val) => props.setBaseVal('dialysisYn', val)}/>
                    </div>
                    <div>심근경색 이력여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('priorMiYn')}
                                    onChange={(val) => props.setBaseVal('priorMiYn', val)}/>
                    </div>
                    <div>뇌졸증 이력</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('priorStrokeYn')}
                                    onChange={(val) => props.setBaseVal('priorStrokeYn', val)}/>
                    </div>
                    <div>심부전으로 인한 병원입원 이력</div>
                    <div className={"col_merge"}>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('priorHfAdmYn')}
                                    onChange={(val) => props.setBaseVal('priorHfAdmYn', val)}/>
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap}>
                <h3>Vital Signs</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={4} colSize={['25%', '75%', '25%', '75%']} rowSize={'56px'}>
                    <div>첫번째 진료실 - 수축기 혈압</div>
                    <div style={{height: "56px"}}>
                        <InputUnitText type={"number"} unit={"mmHg"} value={props.getBaseVal('osys1')}
                                       onChange={(value) => props.setBaseVal('osys1', value)}/>
                    </div>
                    <div>첫번째 진료실 - 이완기 혈압</div>
                    <div style={{height: "56px"}}>
                        <InputUnitText type={"number"} unit={"mmHg"} value={props.getBaseVal('odia1')}
                                       onChange={(value) => props.setBaseVal('odia1', value)}/>
                    </div>
                    <div>첫번째 진료실 - 맥박수</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} value={props.getBaseVal('opr1')}
                                       onChange={(value) => props.setBaseVal('opr1', value)}/>
                    </div>
                    <div>두번째 진료실 - 수축기 혈압</div>
                    <div style={{height: "56px"}}>
                        <InputUnitText type={"number"} unit={"mmHg"} value={props.getBaseVal('osys2')}
                                       onChange={(value) => props.setBaseVal('osys2', value)}/>
                    </div>
                    <div>두번째 진료실 - 이완기 혈압</div>
                    <div style={{height: "56px"}}>
                        <InputUnitText type={"number"} unit={"mmHg"} value={props.getBaseVal('odia2')}
                                       onChange={(value) => props.setBaseVal('odia2', value)}/>
                    </div>
                    <div>두번째 진료실 - 맥박수</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} value={props.getBaseVal('opr2')}
                                       onChange={(value) => props.setBaseVal('opr2', value)}/>
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap}>
                <h3>Medication</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={16} colSize={['25%', '75%', '25%', '75%']} rowSize={'56px'}>
                    <div>ACEi 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('aceiYn')}
                                    onChange={(val) => props.setBaseVal('aceiYn', val)}/>
                    </div>
                    <div>ACEi 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={props.getBaseVal('aceiName')} maxLength={50}
                                       onChange={(value) => props.setBaseVal('aceiName', value)}/>
                    </div>
                    <div>ACEi 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"}
                                       value={props.getBaseVal('aceiDose')}
                                       onChange={(value) => props.setBaseVal('aceiDose', value)}/>
                    </div>
                    <div>ARB 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('arbYn')}
                                    onChange={(val) => props.setBaseVal('arbYn', val)}/>
                    </div>
                    <div>ARB 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={props.getBaseVal('arbName')} maxLength={50}
                                       onChange={(value) => props.setBaseVal('arbName', value)}/>
                    </div>
                    <div>ARB 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"}
                                       value={props.getBaseVal('arbDose')}
                                       onChange={(value) => props.setBaseVal('arbDose', value)}/>
                    </div>
                    <div>Entresto 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('entrestoYn')}
                                    onChange={(val) => props.setBaseVal('entrestoYn', val)}/>
                    </div>
                    <div>Entresto 용량</div>
                    <div>
                        <InputUnitText type={"number"} unit={"mg"} value={props.getBaseVal('entrestoDose')}
                                       onChange={(value) => props.setBaseVal('entrestoDose', value)}/>
                    </div>
                    <div>베타차단제 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('bbYn')}
                                    onChange={(val) => props.setBaseVal('bbYn', val)}/>
                    </div>
                    <div>베타차단제 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={props.getBaseVal('bbName')} maxLength={50}
                                       onChange={(value) => props.setBaseVal('bbName', value)}/>
                    </div>
                    <div>베타차단제 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"} value={props.getBaseVal('bbDose')}
                                       onChange={(value) => props.setBaseVal('bbDose', value)}/>
                    </div>
                    <div>칼슘통로차단제 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('ccbYn')}
                                    onChange={(val) => props.setBaseVal('ccbYn', val)}/>
                    </div>
                    <div>칼슘통로차단제 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={props.getBaseVal('ccbName')} maxLength={50}
                                       onChange={(value) => props.setBaseVal('ccbName', value)}/>
                    </div>
                    <div>칼슘통로차단제 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"} value={props.getBaseVal('ccbDose')}
                                       onChange={(value) => props.setBaseVal('ccbDose', value)}/>
                    </div>
                    <div>이뇨제 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('diureticsYn')}
                                    onChange={(val) => props.setBaseVal('diureticsYn', val)}/>
                    </div>
                    <div>이뇨제 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={props.getBaseVal('diureticsName')} maxLength={50}
                                       onChange={(value) => props.setBaseVal('diureticsName', value)}/>
                    </div>
                    <div>이뇨제 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"} value={props.getBaseVal('diureticsDose')}
                                       onChange={(value) => props.setBaseVal('diureticsDose', value)}/>
                    </div>
                    <div>SGLT2 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('sglt2iYn')}
                                    onChange={(val) => props.setBaseVal('sglt2iYn', val)}/>
                    </div>
                    <div>SGLT2 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={props.getBaseVal('sglt2iName')} maxLength={50}
                                       onChange={(value) => props.setBaseVal('sglt2iName', value)}/>
                    </div>
                    <div>SGLT2 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"} value={props.getBaseVal('sglt2iDose')}
                                       onChange={(value) => props.setBaseVal('sglt2iDose', value)}/>
                    </div>
                    <div>스타틴 혹은 에제티미브 처방여부</div>
                    <div className={"col_merge"}>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('llaYn')}
                                    onChange={(val) => props.setBaseVal('llaYn', val)}/>
                    </div>
                    <div>경구 혈당 강하제 처방여부</div>
                    <div className={"col_merge"}>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('ohaYn')}
                                    onChange={(val) => props.setBaseVal('ohaYn', val)}/>
                    </div>
                    <div>인슐린 처방여부</div>
                    <div className={"col_merge"}>
                        <RadioGroup options={getOptionList('presetYn')} selectedValue={compValue('insulinYn')}
                                    onChange={(val) => props.setBaseVal('insulinYn', val)}/>
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap}>
                <h3>Laboratory</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={8} colSize={['25%', '75%', '25%', '75%']} rowSize={'56px'}>
                    <div>Hb(g/dL)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"g/dL"} value={props.getBaseVal('hb')}
                                       onChange={(value) => props.setBaseVal('hb', value)}/>
                    </div>
                    <div>WBC(x10³/mm³)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"x10³/mm³"} value={props.getBaseVal('wbc')}
                                       onChange={(value) => props.setBaseVal('wbc', value)}/>
                    </div>
                    <div>Platelet(x10³/mm³)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"x10³/mm³"} value={props.getBaseVal('plt')}
                                       onChange={(value) => props.setBaseVal('plt', value)}/>
                    </div>
                    <div>Creatinine(mg/dL)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"mg/dL"} value={props.getBaseVal('cr')}
                                       onChange={(value) => props.setBaseVal('cr', value)}/>
                    </div>
                    <div>AST</div>
                    <div>
                        <InputUnitText type={"number"} unit={"IU/L"} value={props.getBaseVal('ast')}
                                       onChange={(value) => props.setBaseVal('ast', value)}/>
                    </div>
                    <div>ALT</div>
                    <div>
                        <InputUnitText type={"number"} unit={"IU/L"} value={props.getBaseVal('alt')}
                                       onChange={(value) => props.setBaseVal('alt', value)}/>
                    </div>
                    <div>Total Cholesterol(mg/dL)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"mg/dL"} value={props.getBaseVal('totalChol')}
                                       onChange={(value) => props.setBaseVal('totalChol', value)}/>
                    </div>
                    <div>LDL-C(mg/dL)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"mg/dL"} value={props.getBaseVal('ldlC')}
                                       onChange={(value) => props.setBaseVal('ldlC', value)}/>
                    </div>
                    <div>HDL-C(mg/dL)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"mg/dL"} value={props.getBaseVal('hdlC')}
                                       onChange={(value) => props.setBaseVal('hdlC', value)}/>
                    </div>
                    <div>Triglyceride(mg/dL)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"mg/dL"} value={props.getBaseVal('triglyceride')}
                                       onChange={(value) => props.setBaseVal('triglyceride', value)}/>
                    </div>
                    <div>Glucose(mg/dL)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"mg/dL"} value={props.getBaseVal('glucose')}
                                       onChange={(value) => props.setBaseVal('glucose', value)}/>
                    </div>
                    <div>HbA1c(%)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"%"} value={props.getBaseVal('hba1c')}
                                       onChange={(value) => props.setBaseVal('hba1c', value)}/>
                    </div>
                    <div>Hs-CRP(mg/dL)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"mg/dL"} value={props.getBaseVal('hscrp')}
                                       onChange={(value) => props.setBaseVal('hscrp', value)}/>
                    </div>
                    <div>NT-proBNP(pg/mL)</div>
                    <div >
                        <InputUnitText type={"number"} unit={"pg/mL"} value={props.getBaseVal('ntProbnp')}
                                       onChange={(value) => props.setBaseVal('ntProbnp', value)}/>
                    </div>
                    <div>Uric acid(mg/dL)</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg/dL"} value={props.getBaseVal('uricAcid')}
                                       onChange={(value) => props.setBaseVal('uricAcid', value)}/>
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap}>
                <h3>Urine Chemistry</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={2} colSize={['25%', '75%', '25%', '75%']} rowSize={'56px'}>
                    <div>Urine (micro)albumin (mg/L)</div>
                    <div style={{height: "56px"}}>
                        <InputUnitText type={"number"} unit={"mg/L"} value={props.getBaseVal('ualbumin')}
                                       onChange={(value) => props.setBaseVal('ualbumin', value)}/>
                    </div>
                    <div>Urine creatinine(mg/L)</div>
                    <div>
                        <InputUnitText type={"number"} unit={"mg/L"} value={props.getBaseVal('ucreatinine')}
                                       onChange={(value) => props.setBaseVal('ucreatinine', value)}/>
                    </div>
                    <div>Urine Albumin-Creatinine Ratio</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={""} value={props.getBaseVal('uacr')}
                                       onChange={(value) => props.setBaseVal('uacr', value)}/>
                    </div>
                </Table>
            </div>
        </>;


    let renderHtml =
        <></>
    ;

    if (props.contentId === "T1") {
        renderHtml = lesion1Html;

    } else {
        renderHtml = <h3>...</h3>;
    }
    return (
        <>
            {renderHtml}
        </>
    );

};

export default RenderHtml;

